// src/components/home/WhyChooseUsSection.jsx
import React from 'react';
import styles from './WhyChooseUsSection.module.css';
import { FaChalkboardTeacher, FaCode, FaBullseye, FaLightbulb } from 'react-icons/fa';

const WhyChooseUsSection = () => {
  return (
    <section className={styles.whyChooseUsSection}>
      <h2 className={styles.sectionHeading}>Why Choose Bspark?</h2>
      <p className={styles.sectionSubtitle}>
        We are committed to providing top-notch software training that empowers you for a successful career.
      </p>
      <div className={styles.featuresGrid}>
        <div className={styles.featureItem}>
          <FaChalkboardTeacher className={styles.featureIcon} />
          <h3>Industry Expert Trainers</h3>
          <p>Learn directly from seasoned professionals with extensive real-world experience.</p>
        </div>
        <div className={styles.featureItem}>
          <FaCode className={styles.featureIcon} />
          <h3>Hands-On & Project-Based Learning</h3>
          <p>Build strong portfolios with real-time projects and practical exercises.</p>
        </div>
        <div className={styles.featureItem}>
          <FaBullseye className={styles.featureIcon} />
          <h3>100% Placement Assistance</h3>
          <p>Dedicated support for interviews, resume building, and job placements.</p>
        </div>
        <div className={styles.featureItem}>
          <FaLightbulb className={styles.featureIcon} />
          <h3>Flexible Learning Options</h3>
          <p>Choose from online, offline, and hybrid modes to suit your convenience.</p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;